/**
 * **Staah (Max)**
 *
 * @exports bs_236
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
   * @memberOf module:bs_236
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.includes('staahmax');

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();
    return ctx;
  };

  /**
     * @memberOf module:bs_236
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const loader = document.getElementById('loadingOuter');

    if (!thn.staahMaxObserver && loader && thn.isVisible(loader)) { // if loading

      thn.staahMaxObserver = function thnStaahMaxObserver() {
        if (!loader || !thn.isVisible(loader)) { // not loading any more
          // stop observation
          thn.stopObserveDom(loader, thn.staahMaxObserver);
          // delete reference to the observer function
          delete thn.staahMaxObserver;
          // update PW
          ctx.widget.update();
        }
      };

      thn.observeDom(loader, thn.staahMaxObserver, {
        childList: false,
        subtree: false,
        characterData: false,
        attributes: true,
        attributeFilter: ['style'],
      });

      thn.pageUnload(function () {
        thn.stopObserveDom(loader, thn.staahMaxObserver);
        delete thn.staahMaxObserver;
      });
    }
  };

  /**
     * @memberOf module:bs_236
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateBegin = document.querySelector('#dpd1')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    const dateEnd = document.querySelector('#dpd2')?.value?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    let nights;
    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Guests, Adults & Children
    /**
     * Property 1015920: All the rates have 1 adults by default. Guests can only be changed in the next step (before URP).
     */
    const adultsEl = thn.parseNumber(document.querySelector('#s2id_roomadult #select2-chosen-3')?.textContent);
    const childrenEl = thn.parseNumber(document.querySelector('#s2id_roomchild #select2-chosen-2')?.textContent);
    widgetData.adults = adultsEl || 1;
    widgetData.children = childrenEl || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.BEOPrice')].map((price) => thn.parseNumber(price.textContent)).filter(Boolean);
    const minBestRate = document.querySelector('#minbestRate')?.value;
    const price = (!thn.empty(prices) && Math.min(...prices)) || thn.parseNumber(minBestRate);
    const pricePerNight = !!document.querySelector('.BEOPrice')?.textContent?.match(/night/);
    const currency = document.querySelector('.BEOCurrency')?.textContent || thn.parseUrlParameter('currency') || document.querySelector('#s2id_currency .select2-chosen')?.textContent;
    const noAvailability = document.querySelector('#loadData article div.customerrormsg') || minBestRate === 'SOLD'; // No availibility
    if (price && currency && nights) {
      widgetData.price = pricePerNight ? price : price / nights;
      widgetData.currency = thn.parseCurrency(currency);
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_236
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const dataLayer = window.dataLayer;
    const totalPrice = [...document.querySelectorAll('.total')].pop()?.firstChild?.textContent;

    // Booking ID
    widgetData.bookingId = thn.parseUrlParameter('bookingId') || thn.arrayGet(dataLayer, 'transactionId');

    // Dates
    widgetData.dateBegin = (thn.arrayGet(dataLayer, 'checkinDate') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') || thn.parseUrlParameter('checkIn')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    widgetData.dateEnd = (thn.arrayGet(dataLayer, 'checkoutDate') || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2') || thn.parseUrlParameter('checkOut')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');

    // Price & Currency
    widgetData.price = parseFloat(thn.arrayGet(dataLayer, 'transactionTotalWithTax')) || thn.parseNumber(totalPrice);
    widgetData.currency = thn.getCurrencyCode(thn.arrayGet(dataLayer, 'transactionCurrency')) || thn.parseCurrency(totalPrice);

    return widgetData;
  };

  /**
     * @memberOf module:bs_236
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const promoCode = thn.parseUrlParameter('promoCode');

    if (promoCode) {
      ctx.promocode = promoCode;
    }

    return ctx.promocode;
  };

  return engine;

}

export { factory };
